/* eslint-disable react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/indent */
import Product from '@customTypes/product';
import { getDetailedDate, parseMilitaryTime } from '@helpers/date';
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import ButtonPrimary from '@components/common/ButtonPrimary';
import { CartItemDetails } from '@customTypes/cart-items';
import HotelDetails from '@customTypes/hotel-details';
import { store } from '@context/store';
import actionTypes from '@context/actionTypes';
import ButtonLink from '@components/common/ButtonLink';
import BottomDrawerVariant from '@components/common/BottomDrawer/BottomDrawerVariant';
import ProductBannersFactory from './ProductBannersFactory';
import TimeSlotGuestSelector from './TimeSlotGuestSelector';

type Props = {
  cartData: CartItemDetails | undefined;
  date: Date | undefined;
  hotelDetails: HotelDetails;
  isOpen: boolean;
  product: Product;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  showFairPricing: boolean;
};

function TimeSlotGuestSelectorDrawer({
  cartData,
  date,
  hotelDetails,
  isOpen,
  product,
  setIsOpen,
  showFairPricing,
}: Props) {
  const [adultCounter, setAdultCounter] = useState<number>(0);
  const [childrenCounter, setChildrenCounter] = useState<number>(0);

  const { dispatch, state } = useContext(store);
  const { timeSlotGuestBag } = state;

  const handleConfirm = () => {
    dispatch({
      type: actionTypes.SET_TIME_SLOT_GUEST_BAG,
      payload: {
        productId: product.product_id,
        adultsCount: adultCounter,
        childrenCount: childrenCounter,
      },
    });

    setIsOpen(false);
  };

  const handleOnRemoveClick = () => {
    // Reset
    dispatch({
      type: actionTypes.SET_TIME_SLOT_GUEST_BAG,
      payload: {
        productId: 0,
        adultsCount: 0,
        childrenCount: 0,
      },
    });

    setIsOpen(false);
  };

  // Set initial values
  useEffect(() => {
    if (timeSlotGuestBag) {
      setAdultCounter(timeSlotGuestBag.adultsCount);
      setChildrenCounter(timeSlotGuestBag.childrenCount);
    }
  }, [timeSlotGuestBag]);

  return (
    <BottomDrawerVariant
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={product.name}
      subTitle={date && getDetailedDate(new Date(date))}
    >
      <ProductBannersFactory
        cartData={cartData}
        date={date}
        hotelDetails={hotelDetails}
        product={product}
      />

      <div className="w-full px-4 pt-5 pb-5">
        <div className="flex items-center justify-between">
          <p className="font-rp-pn-semi-bold leading-6 text-18">
            {`${parseMilitaryTime(product.start_time)} - ${parseMilitaryTime(product.end_time)}`}
          </p>

          <ButtonLink onClick={handleOnRemoveClick} text="Remove" />
        </div>

        <TimeSlotGuestSelector
          cartData={cartData}
          date={date}
          product={product}
          hotelDetails={hotelDetails}
          showFairPricing={showFairPricing}
          adultCounter={adultCounter}
          childrenCounter={childrenCounter}
          setChildrenCounter={setChildrenCounter}
          setAdultCounter={setAdultCounter}
        />
      </div>

      {/* FOOTER */}
      <div className="absolute backdrop-filter backdrop-blur-27px bg-white bg-opacity-84 border-rp-gray-divider border-t bottom-0 flex justify-between p-4 w-full">
        <div className="flex flex-col leading-22px text-sm">
          <p>Guests</p>

          <p className="font-rp-pn-semi-bold">
            {adultCounter > 0 ? adultCounter + childrenCounter : <span>&#8212;</span>}
          </p>
        </div>

        <ButtonPrimary
          onClick={handleConfirm}
          isDisabled={adultCounter === 0}
          classes="h-12 w-177px"
        >
          Confirm
        </ButtonPrimary>
      </div>
    </BottomDrawerVariant>
  );
}

export default TimeSlotGuestSelectorDrawer;
